export default class PhotomaillageToolType {
    static DELETE_LAST = 'delete_last';

    static DELETE_ALL = 'delete_all';

    static ADD = 'add';
}
